export const BootcampType = [
  { key: 'INTRODUCTION', label: '소개' },
  { key: 'CURRICULUM', label: '커리큘럼' },
  { key: 'INSTRUCTOR', label: '강사소개' },
  { key: 'BOOTCAMP_REVIEW', label: '부트캠프 후기' },
] as const;

export type BootcampType = keyof typeof BootcampType;
